(() => {
  const swatchSelector = '[data-card-variant-swatch]';

  const closestCard = (element) => element.closest('.product-card-wrapper, .complementary-live-card-wrapper');

  const updateLinks = (card, url) => {
    if (!url) return;

    card.querySelectorAll('[data-card-product-link]').forEach((link) => {
      link.href = url;
    });

    card.querySelectorAll('[data-product-url]').forEach((button) => {
      button.dataset.productUrl = url;
    });
  };

  const updateImageElement = (image, src, srcset, alt) => {
    if (!image || !src) return;

    image.src = src;
    if (srcset) {
      image.srcset = srcset;
    }
    if (alt) {
      image.alt = alt;
    }
  };

  const updateImage = (card, swatch) => {
    if (!swatch.dataset.variantImage) return;

    card.querySelectorAll('[data-card-product-image]').forEach((image) => {
      updateImageElement(image, swatch.dataset.variantImage, swatch.dataset.variantSrcset, swatch.dataset.variantImageAlt);
    });

    const variantSecondaryImage = swatch.dataset.variantSecondaryImage || swatch.dataset.variantImage;
    const variantSecondarySrcset = swatch.dataset.variantSecondarySrcset || swatch.dataset.variantSrcset;
    const variantSecondaryAlt = swatch.dataset.variantSecondaryImageAlt || swatch.dataset.variantImageAlt;

    card.querySelectorAll('[data-card-product-secondary-image]').forEach((image) => {
      updateImageElement(image, variantSecondaryImage, variantSecondarySrcset, variantSecondaryAlt);
    });
  };

  const updatePrice = (card, priceHtml) => {
    const price = card.querySelector('[data-card-product-price]');
    if (!price || !priceHtml) return;

    price.innerHTML = priceHtml;
  };

  const updateCardFragment = (card, selector, html) => {
    const target = card.querySelector(selector);
    if (!target || html == null) return;

    target.innerHTML = html;
  };

  const updatePromoBadge = (card, swatch) => {
    const badge = card.querySelector('[data-card-product-promo-badge]');
    if (!badge) return;

    badge.innerHTML = swatch.dataset.variantPromoBadgeHtml || '';
    badge.classList.toggle('product-card__discount-badge--voucher', swatch.dataset.variantPromoBadgeType === 'voucher');
  };

  const updateTitle = (card, variantTitle) => {
    card.querySelectorAll('[data-card-product-title]').forEach((title) => {
      const baseTitle = title.dataset.cardProductBaseTitle || title.textContent.trim();
      title.textContent = variantTitle ? `${baseTitle}, ${variantTitle}` : baseTitle;
    });
  };

  const updateQuickAddVariant = (card, variantId, deliveryTime, available) => {
    if (!variantId) return;

    card.querySelectorAll('[data-card-variant-id-input]').forEach((input) => {
      input.value = variantId;
      input.disabled = !available;
    });

    card.querySelectorAll('[data-card-delivery-time-input]').forEach((input) => {
      input.value = deliveryTime || '';
    });

    card.querySelectorAll('[data-card-variant-submit]').forEach((button) => {
      button.disabled = !available;
      const label = button.querySelector('[data-card-variant-submit-label]');
      if (label) label.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
    });
  };

  const updateActiveSwatch = (card, activeSwatch) => {
    card.querySelectorAll(swatchSelector).forEach((swatch) => {
      const isActive = swatch === activeSwatch;
      swatch.classList.toggle('is-active', isActive);
      swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const card = closestCard(swatch);
    if (!card) return;

    updateActiveSwatch(card, swatch);
    updateLinks(card, swatch.dataset.variantUrl);
    updateImage(card, swatch);
    updateTitle(card, swatch.dataset.variantTitle);
    updateCardFragment(card, '[data-card-product-low-stock]', swatch.dataset.variantLowStockHtml || '');
    updateCardFragment(card, '[data-card-product-installment]', swatch.dataset.variantInstallmentHtml || '');
    updatePrice(card, swatch.dataset.variantPriceHtml);
    updatePromoBadge(card, swatch);
    updateQuickAddVariant(card, swatch.dataset.variantId, swatch.dataset.variantDeliveryTime, swatch.dataset.variantAvailable === 'true');
  });
})();
